/* eslint-disable max-len */
import React from 'react';
import { Button, Dialogs, Flex, Pane } from '@leverege/ui-elements';
import { Toolbar, TitleBar } from '@leverege/ui-plugin';
import { Config } from '@leverege/plugin';
import I18N from '@leverege/i18n';
import StackOverlay from "./StackOverlay.js";
import ToolbarFactory from "./ToolbarFactory.js";
import useStack from "./useStack.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const {
  t,
  tf,
  tIcon
} = I18N.ns('molten.screens.main.ShowOptions');
function Root({
  stack,
  context
}) {
  const {
    clientState: {
      actionsMatchContext,
      actionsContext
    },
    onClose
  } = context;
  let actionsCxt = actionsContext;
  if (typeof actionsContext === 'function') {
    actionsCxt = actionsContext();
  }
  const factory = new ToolbarFactory({
    variant: 'mobileOptBar|mobileNavBar',
    vertical: true,
    stack,
    matchContext: actionsMatchContext
  });
  return /*#__PURE__*/_jsxs(Flex, {
    variant: "col",
    children: [/*#__PURE__*/_jsx(TitleBar, {
      variant: "mobileOptNavTitle",
      title: Config.get('navSecondaryMobile', 'actionsTitle', t('title')),
      children: /*#__PURE__*/_jsx(Button, {
        variant: "mobileNavClose",
        icon: Config.get('Main', 'closeIcon', 'https://molten-ui-assets.storage.googleapis.com/close.svg'),
        onClick: onClose
      })
    }), !stack.isEmpty() && /*#__PURE__*/_jsx(TitleBar, {
      variant: "mobileNavTitle",
      children: /*#__PURE__*/_jsx(Button, {
        variant: "mobileNavBack",
        onClick: stack.pop,
        children: t('back')
      })
    }), /*#__PURE__*/_jsx(Toolbar, {
      factory: factory,
      vertical: true,
      variant: "mobileOptBar|mobileNavBar",
      matchContext: actionsMatchContext,
      context: {
        ...actionsCxt,
        onClose
      }
    })]
  });
}
function showOverlay(cxt) {
  Dialogs.show({
    component: props => {
      const {
        show,
        onClose
      } = props;

      // eslint-disable-next-line react-hooks/rules-of-hooks
      const stack = useStack();
      const renderer = stack => {
        return /*#__PURE__*/_jsx(Pane, {
          variant: "mobileOptNav",
          children: /*#__PURE__*/_jsx(Root, {
            stack: stack,
            context: {
              ...cxt,
              show,
              onClose
            }
          })
        });
      };
      return /*#__PURE__*/_jsx(StackOverlay, {
        mode: "single",
        stack: stack,
        renderer: renderer,
        show: show,
        onClose: onClose,
        position: "bottom",
        animation: "slideFromBottom"
      });
    },
    props: {},
    id: 'mobileItemScreenNavActions'
  });
}
export default {
  id: 'molten.screens.main.ShowOptions',
  name: tf('name'),
  // visible in all group screens
  matches: {
    use: 'headerOptions',
    client: 'Main'
  },
  handles: () => true,
  appearance: () => {
    return {
      icon: tIcon('icon', 'fa fa-ellipsis-v fa-fw')
    };
  },
  perform: ({
    context
  }) => {
    showOverlay(context);
  }
};